import React from 'react';
import { Scale, Phone } from 'lucide-react';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 glass" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-49">
        <div className="flex justify-between items-center h-20" data-id="element-50">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-51">
            <div className="w-10 h-10 bg-slate-900 rounded-xl flex items-center justify-center shadow-lg shadow-slate-900/10" data-id="element-52">
              <Scale size={20} className="text-white" data-id="element-53" />
            </div>
            <div data-id="element-54">
              <h1 className="font-bold text-xl text-slate-900 tracking-tight leading-none mb-1" data-id="element-55">
                Правовий елемент
              </h1>
              <p className="text-[11px] text-slate-500 font-semibold tracking-wider uppercase" data-id="element-56">
                Адвокатське об'єднання
              </p>
            </div>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-57">
            <a href="#services" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-58">
              Послуги
            </a>
            <a href="#process" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-59">
              Як ми працюємо
            </a>
            <a href="#contact" className="text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-60">
              Контакти
            </a>
          </nav>

          {/* CTA */}
          <div className="flex items-center gap-5" data-id="element-61">
            <a href="tel:+380634259030" className="hidden lg:flex items-center gap-2 text-sm font-bold text-slate-700 hover:text-slate-900 transition-colors" data-id="element-62">
              <Phone size={16} data-id="element-63" />
              +38 063 425 90 30
            </a>
            <a href="#contact" className="bg-slate-900 hover:bg-slate-800 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-all shadow-md hover:shadow-lg" data-id="element-64">
              Консультація
            </a>
          </div>
        </div>
      </div>
    </header>;
}